export default {
  init() {
    // JavaScript to be fired on all pages

    $('.products .product_cat-pick-up-only .card .woocommerce-LoopProduct-link').prepend('<span class="pickup onsale">This item is pick up only</span>');

    $('.modal-body .create').hide();
    $('.modal-body .forgot').hide();

    $('#choice input[type="radio"]').click(function(){
      var inputValue = $(this).attr('value');
      var targetBox = $('.' + inputValue);
      $('.modal-body .body').not(targetBox).hide();
      $(targetBox).show();
    });

    $('.modal-body #reset').click(function() {
      $('.modal-body .signin').hide();
      $('.modal-body .create').hide();
      $('.modal-body .forgot').show();
    });
/*
    $('.top-cart.not-empty').on('click', function() {
      event.preventDefault();
      $('.cart-dropdown').toggleClass('show');
      $('.cart-backdrop').toggleClass('show');
    });

    $('.cart-backdrop').on('click', function() {
      $('.cart-dropdown').removeClass('show');
      $('.cart-backdrop').removeClass('show');
    });
*/
    // $('.navbar-toggler').click(function() {
    //   $(this).toggleClass('toggle-open');
    //   $('body').toggleClass('noscroll');
    //   $('header').toggleClass('header-open');
    //   $('body .mobile-backdrop').toggleClass('show');
    // });

    // $('#back').on('click', function() {
    //   $('.dropdown-menu').removeClass('show');
    // });

    // $('.dropdown .dropdown-toggle').on('click', function() {
    //   $('body .mobile-backdrop').toggleClass('show');
    //   $('body').toggleClass('noscroll');
    // });

    $('.checkout-progress-bar #carttablink a[href="#carttab"]').on('click', function() {
      event.preventDefault();
      $('.checkout-progress-bar aside a').removeClass('active');
      $(this).addClass('active');
      $('.checkout-progress-bar .progress .progress-bar').removeClass('one-third').removeClass('two-third').removeClass('full');
      $('.woo-checkout section').removeClass('show-section');
      $('.woo-checkout .carttab').addClass('show-section');
    });
    //
    // $('.checkout-progress-bar #delivery a').on('click', function() {
    //   event.preventDefault();
    //   $(this).toggleClass('active');
    //   $('.checkout-progress-bar .progress .progress-bar').toggleClass('one-third');
    //   $('.woo-checkout section').removeClass('show-section');
    //   $('.woo-checkout .delivery').addClass('show-section');
    // });

    $('.checkout-progress-bar #pay a[href="#"]').on('click', function() {
      event.preventDefault();
      $(this).toggleClass('active');
      $('.checkout-progress-bar .progress .progress-bar').toggleClass('two-third');
      $('.woo-checkout section').removeClass('show-section');
      $('.woo-checkout .pay').addClass('show-section');
    });

    $('.checkout-progress-bar #confirm a').on('click', function() {
      event.preventDefault();
      $(this).toggleClass('active');
      $('.checkout-progress-bar .progress .progress-bar').toggleClass('full');
      $('.woo-checkout section').removeClass('show-section');
      $('.woo-checkout .confirm').addClass('show-section');
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired


    console.log('just one more');


    function setuppagination() {
      var more = $('.page-numbers.next').attr('href');
      console.log(more);
      if( !more )
        return;

      $('.page-numbers').hide();
      justonemore(more);

      $(window).scroll(function () {
        var more = $('ul.products').data('next');
        if( more ) {
          var hT = $('nav.woocommerce-pagination').offset().top,
              hH = $('nav.woocommerce-pagination').outerHeight(),
              wH = $(window).height(),
              wS = $(this).scrollTop();
          if (wS > (hT + hH - wH)) {
            justonemore($('ul.products').data('next'));
          }
        }
      });
    }

    var pageurls = [];

    function justonemore( url ) {
      if( !url ) return;

      var skip = $('ul.products').data('skip');

      if( !skip ) {
        $('ul.products').data('skip', true);

        $('section.winery_shop').append('<div id="shopspinner" class="d-flex flex-row"><img class="mx-auto my-3" src="/wp-content/themes/13thwinery/resources/assets/images/Rotatingrings.gif" /></div>');
        $.ajax({
          url: url,
          method: 'GET',
          success: function (response) {

            pageurls.push(url);

            // add products
            $('ul.products').append($(response).find('ul.products').html());
            
            // get new pagination link
            const next = $(response).find('a.next.page-numbers').attr('href');

            if( next && !pageurls.includes(next) ) {
              console.log('still more');
              console.log(next);
              console.log(pageurls);
              $('ul.products').data('next', next);
            } else {
              console.log('no more');
              $('ul.products').data('next', false);
            }

            // set new trigger for next page
            $('ul.products').data('skip', false);

            $('#shopspinner').remove();
          },
        });
      }
    }



    setuppagination();

    $(window).on('wcpf_after_ajax_filtering', setuppagination);
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js